export default __webpack_public_path__ + "static/game-2-a5947f945f17a9ab12b2a6094aa636d9.png";